import { cloneDeep } from "lodash";
import {
  APPLICATION_TAB_NAMES,
  JOB_APPLICATION_MATCH_STATUS,
  SOCIAL_LINK_TYPES,
  USER_STATUS,
} from "lookup";
import { getUserName } from "./users";

const mapMatch = (match, isPreCandidatesTab) => {
  const item = {
    match,
    ...match.user,
    isDeleting: false,
    isMatching: false,
  };

  if (isPreCandidatesTab && item.match?.matchAgent) {
    try {
      item.rankDetails = JSON.parse(item.match.matchAgent);
    } catch (error) {
      console.log("Invalid match.matchAgent Format");
    }
  }

  return item;
};

export const mapMatchesToHit = (
  matches,
  status,
  activeTabName,
  excludedStatuses = []
) => {
  const isPreCandidatesTab =
    activeTabName === APPLICATION_TAB_NAMES.PRECANDIDATES;

  const isLongListTab = activeTabName === APPLICATION_TAB_NAMES.LONGLISTED;

  const clonedMatches = cloneDeep(matches);
  const filteredMatches = clonedMatches.filter((m) => {
    if (!m.user) {
      return false;
    }

    if (m.user.status !== USER_STATUS.ACTIVE) {
      return false;
    }

    m.user.socialLinks = m.user.socialLinks
      ? m.user.socialLinks.filter(
          (s) => !!s.value && s.type !== SOCIAL_LINK_TYPES.CALENDAR
        )
      : [];

    if (m.user.ratings?.torc) {
      try {
        m.user.ratings.torc = JSON.parse(m.user.ratings.torc);
      } catch (err) {
        console.log(
          `${getUserName(
            m.user
          )} does not have valid ratings. Cannot parse JSON.`
        );
      }
    }

    if (status) return status.includes(m.status);

    if (isLongListTab) return true;

    return !excludedStatuses.includes(m.status);
  });

  const finalMatches = filteredMatches.map((item) =>
    mapMatch(item, isPreCandidatesTab)
  );

  return finalMatches;
};

export const isMatchPreShortlistedStatusType = (status) => {
  if (!status) {
    return false;
  }

  const preShortListedStatuses = [
    JOB_APPLICATION_MATCH_STATUS.PRESHORTLISTED,
    JOB_APPLICATION_MATCH_STATUS.TKSHORTLISTED,
  ];

  return preShortListedStatuses.includes(status);
};

export const isCoveredJobMatchStatusError = (error) => {
  const message = error?.errors?.[0]?.message || "";

  return (
    message.includes("Unable to mark match status:") &&
    message.includes("for job with status: COVERED")
  );
};
